<template>
  <div class="notification-box-modal">
    <div class="notification-box" :class="boxClass">
      <slot name="header"></slot>
      <slot name="body"></slot>
      <slot name="footer">
        <div class="notification-box-footer">
          <div class="mfp-close-button button button-black" @click="closeModal()" v-text="getCloseButtonText()"></div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "modalTemplate",
  props: ['onClose', 'boxClass', 'modalClass', 'closeButtonText'],
  methods:{
    closeModal: function (){
      this.$store.commit(this.onClose, false);
    },
    getCloseButtonText: function (){
      return this.closeButtonText !== undefined ? this.closeButtonText : this.phrases.TEXT_BUTTON_CLOSE;
    }
  },
  computed:{
    ...mapGetters('app', {
      phrases: 'getPhrases',
    }),
  }
}
</script>

<style scoped lang="scss">
</style>
